import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EventDetailsVM } from '@libs/store';
import { HourToDayPartHourPipe, HourToDayPartPipe } from '@libs/utils';
import { PadStartPipe } from '../pad-start/pad-start.pipe';

@Component({
  selector: 'lib-event-details',
  templateUrl: './event-details.component.html',
  styleUrl: './event-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, DatePipe, PadStartPipe, HourToDayPartPipe, HourToDayPartHourPipe],
})
export class EventDetailsComponent {
  public readonly eventDetails = input<EventDetailsVM>();
}
